// extracted by mini-css-extract-plugin
module.exports = {"container":"imageCode_container__dBSmD","title":"imageCode_title__2dF_X","box":"imageCode_box__cK-0n","insta":"imageCode_insta__gCePh"};